import React, { useState } from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, BarChart, Bar } from 'recharts';
import styles from './ApplicationStatusChart.module.scss';
import { Height, MoreVert as MoreVertIcon } from '@mui/icons-material';
import {StudentRatioProps} from "../../types/types";

const CustomizedAxisTick = (props: any) => {
  const { x, y, payload } = props;

  // Word wrapping: split by space or limit characters per line
  const words = payload.value.toString().split(" ");
  const maxChars = 20;
  const lines: string[] = [];

  let currentLine = "";
  words.forEach((word:any) => {
    if ((currentLine + " " + word).trim().length > maxChars) {
      lines.push(currentLine.trim());
      currentLine = word;
    } else {
      currentLine += " " + word;
    }
  });
  if (currentLine) lines.push(currentLine.trim());

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        textAnchor="end"
        transform="rotate(-60)" // 🔄 rotation
        fontSize={8.5}           // ✅ smaller font size
        fill="var(--mui-palette-text-secondary)"
        fontFamily='"Roboto", "Helvetica", "Arial", sans-serif'
        fontWeight={400}
        lengthAdjust={"spacingAndGlyphs"}
      >
        {lines.map((line, index) => (
          <tspan x={0} dy={index === 0 ? 0 : 12} key={index}>{line}</tspan>
        ))}
      </text>
    </g>
  );
};
const ApplicationStatusChart: React.FC<StudentRatioProps> = ({studentRatio}) => {
  const [hiddenKeys, setHiddenKeys] = useState<string[]>([]);

  const handleLegendClick = (e: any) => {
    const { dataKey } = e;
    setHiddenKeys((prev) =>
      prev.includes(dataKey)
        ? prev.filter((k) => k !== dataKey) // show if hidden
        : [...prev, dataKey]               // hide if visible
    );
  };
  return (
    <Card className={styles.chartCard}>
      <CardContent>
        <Box className={styles.header}>
          <Typography variant="h6" className={styles.title} sx={{ color: 'var(--mui-palette-text-primary)' }}>
            Students by Course & Gender
          </Typography>
          <MoreVertIcon sx={{ color: 'var(--mui-palette-text-secondary)' }} />
        </Box>
        <Box className={styles.legendContainer}>
        <Box className={styles.legendItem}>
          <span className={styles.legendDot} style={{ backgroundColor: '#42A5F5' }}></span>
          <Typography variant="body2" sx={{ color: 'var(--mui-palette-text-secondary)' }}>
            Male
          </Typography>
        </Box>
        <Box className={styles.legendItem}>
          <span className={styles.legendDot} style={{ backgroundColor: '#EC407A' }}></span>
          <Typography variant="body2" sx={{ color: 'var(--mui-palette-text-secondary)' }}>
            Female
          </Typography>
        </Box>
         
      </Box>

        <Box className={styles.chartWrapper} style={{  height: 'auto' }}>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart
              data={studentRatio}
              margin={{
                top: 0,
                right: 30,
                left: 20,
                bottom: 0,
              }}
            >
              <XAxis dataKey="course" stroke="var(--mui-palette-text-secondary)" tick={<CustomizedAxisTick />} interval={0} height={70} />
              <YAxis stroke="var(--mui-palette-text-secondary)" tick={{ fontSize: 12 }} />
              <Tooltip
                contentStyle={{
                  backgroundColor: 'var(--mui-palette-background-paper)',
                  border: '1px solid var(--mui-palette-divider)',
                  borderRadius: '8px',
                  fontSize: '10px',
                  color: 'var(--mui-palette-text-primary)',
                }}
                labelStyle={{ color: 'var(--mui-palette-text-primary)' }}
                itemStyle={{ color: 'var(--mui-palette-text-secondary)' }}
              />
              <Legend onClick={handleLegendClick} wrapperStyle={{ color: 'var(--mui-palette-text-secondary)', cursor: 'pointer' }} />
              <Bar dataKey="male" stackId="a" fill="#42A5F5" name="Male" hide={hiddenKeys.includes("male")} />
              <Bar dataKey="female" stackId="a" fill="#EC407A" name="Female" hide={hiddenKeys.includes("female")} />
            </BarChart>
          </ResponsiveContainer>
          <Box sx={{paddingTop: '1rem'}}>
            <Typography variant="body2" sx={{ color: 'var(--mui-palette-text-secondary)' }}>
             Note: <span style={{fontWeight: 700}}>Other -</span> Indicates stream of study for up to class X.
            </Typography>
          </Box>

        </Box>
      </CardContent>
    </Card>
  );
};

export default ApplicationStatusChart;